import styled from "styled-components";
import { fadeUp, fadeIn, animatedBase } from "../theme/animations";

export const Section = styled.section`
  max-width: ${({ fullWidth }) => (fullWidth ? "100%" : "1120px")};
  margin: 0 auto;
  padding: ${({ fullWidth }) => (fullWidth ? "0 24px" : "48px 12px")};

  @media (max-width: 768px) {
    padding: ${({ fullWidth }) => (fullWidth ? "0 20px" : "72px 20px")};
  }
`;

export const SectionHeading = styled.h2`
  text-align: center;
  font-size: ${({ theme }) => theme.typography.h2};
  margin: 0 0 24px;
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  max-width: 640px;
  margin: 0 auto 48px;
  color: ${({ theme }) => theme.muted};
  line-height: 1.6;
`;

export const AnimatedCard = styled.div`
  ${animatedBase};
  animation: ${fadeUp} 0.6s ease forwards;
`;

export const FadeInBlock = styled.div`
  ${animatedBase};
  animation: ${fadeIn} 0.5s ease forwards;
`;
